import React, { Component, Fragment } from "react";
import axios from "../../containers/api";
import { Row, Card, CardBody, CardTitle, Button } from "reactstrap";
import { Colxx } from "../../components/common/CustomBootstrap";
import { Link } from "react-router-dom";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell
} from "recharts";

const COLORS = ["#4361ee", "#2ecc71", "#f39c12", "#e74c3c"];

export default class TransportationCompanyMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agentStatistics: null
    };
  }

  componentDidMount() {
    // this.getAgentStatistics();
  }

  getAgentStatistics = () => {
    this.props.showSpinner();
    axios.get('api/v1/Cargo/GetTransportationCompanyStatisticalInformation')
      .then((res) => {
        this.props.hideSpinner();
        this.setState({ agentStatistics: res.data.data });
      })
      .catch((error) => {
        this.props.hideSpinner();
        console.log(error.response);
      });
  };

  render() {
    const chartData = [
      { name: "فروردین", reserves: 120 },
      { name: "اردیبهشت", reserves: 200 },
      { name: "خرداد", reserves: 150 },
      { name: "تیر", reserves: 300 },
      { name: "مرداد", reserves: 250 }
    ];

    const pieData = [
      { name: "اعلام بار", value: 100 },
      { name: "مجوز صادر شده", value: 60 }
    ];

    return (
      <Fragment>
        {/* استایل‌های داخلی */}
        <style jsx>{`
          .dashboard-container {
            font-family: 'Vazir', 'Tahoma', sans-serif;
            direction: rtl;
          }
          .btn-custom {
            transition: all 0.3s ease;
            border-radius: 12px;
            font-weight: 600;
            padding: 10px 20px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          }
          .btn-custom:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(0,0,0,0.15);
          }
          .card-custom {
            border: none;
            border-radius: 16px;
            overflow: hidden;
            box-shadow: 0 8px 25px rgba(0,0,0,0.08);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
            margin-bottom: 1.5rem;
          }
          .card-custom:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 35px rgba(0,0,0,0.12);
          }
          .card-title-custom {
            font-size: 1.1rem;
            font-weight: 700;
            color: #2d3436;
            margin-bottom: 1rem;
            text-align: center;
          }
          .dashboard-card-numbers {
            font-size: 2.8rem;
            font-weight: 800;
            color: #4361ee;
            text-shadow: 0 2px 4px rgba(67, 97, 238, 0.2);
          }
          .chart-container {
            padding: 10px;
          }
          .recharts-text tspan {
            font-weight: 600 !important;
            fill: #2d3436 !important;
          }
          .recharts-tooltip {
            background: rgba(255,255,255,0.95) !important;
            border: 1px solid #ddd !important;
            border-radius: 12px !important;
            padding: 10px !important;
            box-shadow: 0 5px 15px rgba(0,0,0,0.1) !important;
          }
          @media (max-width: 768px) {
            .dashboard-card-numbers {
              font-size: 2.2rem;
            }
            .btn-custom {
              font-size: 0.9rem;
              padding: 8px 16px;
            }
          }
        `}</style>

        <div className="dashboard-container">
          {/* دکمه‌های اصلی */}
          <Row className="mb-4">
            <Colxx xxs="12">
              <Card className="card-custom">
                <CardBody className="d-flex flex-md-row flex-column justify-content-center gap-3 p-4">
                  <Link to="/AddCargo">
                    <Button className="btn-custom" color="primary">
                     ثبت بار جدید
                    </Button>
                  </Link>
                  <Link to="/Cargos">
                    <Button className="btn-custom" color="success">
                      مدیریت بار ثبت شده
                    </Button>
                  </Link>
                  <Link to="/DriverReserves">
                    <Button className="btn-custom" color="info" style={{ backgroundColor: '#17a2b8', border: 'none' }}>
                    مدیریت مجوز بارگیری 
                    </Button>
                  </Link>
                </CardBody>
              </Card>
            </Colxx>
          </Row>

          {/* کارت‌های آماری */}
          <Row className="mb-4">
            <Colxx xl="4" lg="4" md="6" sm="12">
              <Card className="card-custom text-center">
                <CardBody>
                  <CardTitle className="card-title-custom">تعداد کل بارهای اعلام شده</CardTitle>
                  <div className="dashboard-card-numbers">100</div>
                  <small style={{ color: '#74b9ff' }}>از ابتدای فعالیت</small>
                </CardBody>
              </Card>
            </Colxx>

            <Colxx xl="4" lg="4" md="6" sm="12">
              <Card className="card-custom text-center">
                <CardBody>
                  <CardTitle className="card-title-custom">بارهای در حال ارسال</CardTitle>
                  <div className="dashboard-card-numbers" style={{ color: '#f39c12' }}>20</div>
                  <small style={{ color: '#fdcb6e' }}>در مسیر</small>
                </CardBody>
              </Card>
            </Colxx>

            <Colxx xl="4" lg="4" md="12" sm="12">
              <Card className="card-custom text-center">
                <CardBody>
                  <CardTitle className="card-title-custom">مجوزهای صادر شده</CardTitle>
                  <div className="dashboard-card-numbers" style={{ color: '#2ecc71' }}>60</div>
                  <small style={{ color: '#00b894' }}>تأیید شده</small>
                </CardBody>
              </Card>
            </Colxx>
          </Row>

          {/* نمودارها */}
          <Row>
            {/* نمودار دایره‌ای */}
            <Colxx xl="6" md="6">
              <Card className="card-custom">
                <CardBody className="chart-container">
                  <CardTitle className="card-title-custom text-center mb-4">
                    درصد اعلام بار و مجوز
                  </CardTitle>
                  <ResponsiveContainer width="100%" height={320}>
                    <PieChart>
                      <Pie
                        data={pieData}
                        dataKey="value"
                        nameKey="name"
                        cx="50%"
                        cy="50%"
                        outerRadius={110}
                        label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                        labelStyle={{ fontSize: '14px', fontWeight: '600' }}
                      >
                        {pieData.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                      </Pie>
                      <Tooltip formatter={(value) => `${value} مورد`} />
                    </PieChart>
                  </ResponsiveContainer>
                </CardBody>
              </Card>
            </Colxx>

            {/* نمودار خطی */}
            <Colxx xl="6" md="6">
              <Card className="card-custom">
                <CardBody className="chart-container">
                  <CardTitle className="card-title-custom text-center mb-4">
                    آمار رزروها در ماه‌های اخیر
                  </CardTitle>
                  <ResponsiveContainer width="100%" height={320}>
                    <LineChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                      <CartesianGrid strokeDasharray="4 4" stroke="#f0f0f0" />
                      <XAxis 
                        dataKey="name" 
                        tick={{ fill: '#2d3436', fontWeight: '600' }}
                        axisLine={{ stroke: '#ddd' }}
                      />
                      <YAxis 
                        tick={{ fill: '#2d3436', fontWeight: '600' }}
                        axisLine={{ stroke: '#ddd' }}
                      />
                      <Tooltip 
                        contentStyle={{ 
                          borderRadius: '12px', 
                          border: 'none', 
                          boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                          backgroundColor: '#fff'
                        }}
                      />
                      <Line 
                        type="monotone" 
                        dataKey="reserves" 
                        stroke="#4361ee" 
                        strokeWidth={4}
                        dot={{ fill: '#4361ee', r: 6 }}
                        activeDot={{ r: 8 }}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </CardBody>
              </Card>
            </Colxx>
          </Row>
        </div>
      </Fragment>
    );
  }
}